import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SubHeaderComponent } from './header/sub-header/sub-header.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DesktopMenuComponent } from './header/desktop-menu/desktop-menu.component';
import { MobileDropdownComponent } from './header/mobile-dropdown/mobile-dropdown.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TimeoutDialogComponent } from './timeout-dialog/timeout-dialog.component';
import { SessionTimeoutService } from './shared/services/session-timeout.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCommonModule } from '@angular/material/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiService } from './shared/services/api.service';
import { OAuthService } from './shared/services/authorization/oauth.service';
import { MatIconModule } from '@angular/material/icon';
import { ReportsModule } from './reports/reports.module';
import { MyProfileModule } from './my-profile/my-profile.module';
import { AdminModule } from './admin/admin.module';
import { CallbackComponent } from './callback/callback.component';
import { environment } from '../environments/environment';
import { ExternalUrlDirective } from './shared/directives/external-url.directive';
import { ContactUsModule } from './contact-us/contact-us.module';
import { GuideModule } from './guide/guide.module';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { SubFooterComponent } from './footer/sub-footer/sub-footer.component';
import { MainFooterComponent } from './footer/main-footer/main-footer.component';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { SelectedLoanService } from './shared/services/selected-loan.service';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PermissionService } from './shared/services/permission.service';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { MatCheckboxModule } from '@angular/material';
import { AppConfig } from './app-config';
import { MaintenanceFooterComponent } from './footer/maintenance-footer/maintenance-footer.component';
import { CompanyDropdownComponent } from './header/company-dropdown/company-dropdown.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { CustomPingInterceptor } from './interceptors/custom-ping-interceptor.service';
import { LoanImagesModule } from './loan-images/loan-images.module';
import { NavFooterComponent } from './footer/nav-footer/nav-footer.component';

export function appConfigFactory(appConfig: AppConfig): Function {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SubHeaderComponent,
    DesktopMenuComponent,
    MobileDropdownComponent,
    MaintenanceComponent,
    TimeoutDialogComponent,
    ExternalUrlDirective,
    FooterComponent,
    MainFooterComponent,
    SubFooterComponent,
    MaintenanceFooterComponent,
    CallbackComponent,
    PageNotFoundComponent,
    TermsAndConditionsComponent,
    CompanyDropdownComponent,
    AccessDeniedComponent,
    NavFooterComponent,
  ],
  imports: [
    BrowserModule,
    GuideModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SharedModule,
    AppRoutingModule,
    AppRoutingModule,
    HttpClientModule,
    MatCommonModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatIconModule,
    ReportsModule,
    MyProfileModule,
    AdminModule,
    ContactUsModule,
    MatCheckboxModule,
    LoanImagesModule
  ],
  exports: [],
  providers: [
    SessionTimeoutService,
    ApiService,
    OAuthService,
    SelectedLoanService,
    PermissionService,
    AppConfig,
    { provide: 'AuthorizationConfig', useValue: environment },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: appConfigFactory, deps: [AppConfig], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CustomPingInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  entryComponents: [TimeoutDialogComponent]
})
export class AppModule { }
